import React, { useState } from 'react';
import { BodySmallText, TitleSmallText } from '@prisjakt/ui/text/variants';
import { Alignment, Popover } from '@prisjakt/ui/popover';
import { IconInfoOutlined } from '@prisjakt/ui/icon/info-outlined';
import { Clickable } from '@prisjakt/ui/clickable';
import { useAppContext } from 'src/components/app-context';
import {
  StyledIconWrapper,
  StyledBlueInfoPageLink,
  StyledPopoverContent,
  TitleRow,
} from './styles';

export const OurChoiceHeader = () => {
  const { t, market } = useAppContext();
  const [showPopover, setShowPopover] = useState(false);

  return (
    <TitleRow>
      <TitleSmallText>{t('product', 'prices.our-choice')}</TitleSmallText>

      <Clickable
        onClick={() => setShowPopover(!showPopover)}
        containerProps={{
          title: t('common', 'button.read-more'),
          'aria-label': t('common', 'button.read-more'),
          'aria-haspopup': 'dialog',
        }}
      >
        <StyledIconWrapper>
          <IconInfoOutlined color="base600" size={16} />
        </StyledIconWrapper>
      </Clickable>

      <Popover
        id="our-choice-explanation"
        visible={showPopover}
        width={300}
        horizontalAlign={Alignment.Center}
        verticalAlign={Alignment.Center}
        onClose={() => setShowPopover(false)}
      >
        <StyledPopoverContent>
          <BodySmallText>
            {t('product', 'prices.our-choice-explanation')}
          </BodySmallText>
          <StyledBlueInfoPageLink id={market.infoPageMap?.priceInformation}>
            <TitleSmallText>{t('common', 'button.read-more')}</TitleSmallText>
          </StyledBlueInfoPageLink>
        </StyledPopoverContent>
      </Popover>
    </TitleRow>
  );
};
